import axios from 'axios';
import getRequestData from "@/helpers/get-request-data";
import getRequestHeaders from "@/helpers/get-request-headers";
import Service from "@/abstracts/service";

class interactiveLinkService extends Service {
    constructor() {
        super('p00017');
    }

    /**
     * @returns {Promise<Object>}
     */
    listProjects() {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_PROJECT_LIST_PROJECT",
                liveUsageDeadline: 600
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let projects = [];

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        projects = payload.data.list;
                    }

                    resolve(projects);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    /**
     * @param {String} project
     * @returns {Promise<Object>}
     */
    getProject(project) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_PROJECT_GET_PROJECT",
                project: project
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let project = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        project = payload.data;
                    }

                    resolve(project);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    /**
     * @param {String} profile
     * @param {String} format
     * @returns {Promise<Object>}
     */
    executeExport(profile, format) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_EXPORT_EXECUTE_EXPORT",
                profile: profile,
                exportFormat: format
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let exportData = {};

                    if (response.status === 200) {
                        exportData = response.data;
                    }

                    resolve(exportData);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    /**
     * @param {String} domain
     * @param {Object} parameters
     * @param {Array}  licenses
     * @returns {Promise<Object>}
     */
    createQuickViewUrl(domain, parameters, licenses) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: 'ADMIN_QUICKVIEW_CREATE_URL',
                domain: domain,
                parameters: parameters,
                licenses: licenses
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let createQuickViewUrl;

                    if (response.status === 200) {
                        createQuickViewUrl = response.data;
                    }

                    resolve(createQuickViewUrl);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}

export default new interactiveLinkService();